import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { fetchAuthSession } from 'aws-amplify/auth';

import { apolloConfig } from 'src/config/aws-exports';

const uri = apolloConfig.devGraphqlEndpoint;

const httpLink = createHttpLink({
  uri,
});

const authLink = setContext(async (_, { headers }) => {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString() ?? '';
  return {
    headers: {
      ...headers,
      Authorization: token,
      'x-api-key': process.env.REACT_APP_DEV_X_API_KEY,
    },
  };
});

const cache = new InMemoryCache();

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
});

export default client;
